import { Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { RoleDetail } from "./signing-page.dto";
import { SigningStatusEnum } from "../enums/enum";
import { Field } from "app/interfaces/fields";
import { Block } from "app/interfaces/blocks";
import { DomHelperService } from "app/global/dom-helper.service";
import { GlobalService } from "app/global/global.service";
import { AreaType } from "app/global/dom-handler.dto";
import {productTable} from 'app/main/pages/general-editor-tabs/product-table/productTable';

@Injectable({
    providedIn: 'root'
})
export class SigningPageEventService {
    constructor(rendererFactory: RendererFactory2, private domHelperService: DomHelperService, private globalService: GlobalService, private productTable: productTable) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    private renderer: Renderer2;
    public signingStatusEnum = SigningStatusEnum;

    isSignatureBox(fields_data: object, roleDetail: RoleDetail){
        let assignedSignatureBox:boolean = false;
        for (const uuid in fields_data) {
            if (fields_data[uuid]) {
                const field: Field = fields_data[uuid];
                if (field.type == "signature" && document.querySelector('.drag-fields[uuid="' + field.uuid + '"]') && (Number(field.selected_for_role_id) == roleDetail.id || field.selected_for_role_id == -1)) {
                    assignedSignatureBox = true;
                    break;
                }
            }
        }
        return assignedSignatureBox;
    }    

    /**
     * init the event listners for the signing area
     * @param fields_data 
     * @param roleDetail 
     */
    
    initEvent(fields_data: object, roleDetail: RoleDetail, isEform:boolean = false) {
        document.querySelectorAll('.template-page [contenteditable="true"]').forEach((ele) => {
            this.renderer.setAttribute(ele, 'contenteditable', 'false');
        });
        this.initTheAssigner(fields_data, roleDetail, isEform);
    }

    /**
   * init the assigner fields when load signing area
   * @param fields_data 
   * @param roleDetail 
   */
    initTheAssigner(fields_data: object, roleDetail: RoleDetail, isEform) {
        for (const uuid in fields_data) {
            if (fields_data[uuid]) {
                this.fieldAssigner(uuid, fields_data, roleDetail, isEform);
            }
        }
        //for the blocks
        if (fields_data['blocks']) {
            for (const blockUuid in fields_data['blocks']) {
                if (fields_data['blocks'][blockUuid]) {
                    this.blockAssigner(blockUuid, fields_data, roleDetail, isEform);
                }
            }
        }
    }

    /**
       * event listening for the each field
       * @param uuid 
       * @param fields_data 
       * @param roleDetail 
       */
    fieldAssigner(uuid: string, fields_data: object, roleDetail: RoleDetail, isEform:boolean) {
        const field: Field = fields_data[uuid];
        const fieldLock = field?.lock === 1 ? 1 : 0;
        if ((Number(field.selected_for_role_id) == roleDetail.id || field.selected_for_role_id == -1) && ([this.signingStatusEnum.SENT, this.signingStatusEnum.DELIVERED, this.signingStatusEnum.VIEWED].includes(roleDetail?.recipient_role_detail?.status) || isEform) && fieldLock === 0) {
            const pointerNone = document.querySelector('.drag-fields[uuid="' + field.uuid + '"]') as HTMLElement;
            const droplistPointerNone = document.querySelector('.drag-fields[uuid="' + field.uuid + '"]');
            const assignee = document.querySelector('.drag-fields[uuid="' + field.uuid + '"]') as HTMLElement;
            const senderInput = pointerNone?.querySelector('input') as HTMLElement;
            const senderTextarea = pointerNone?.querySelector(' textarea') as HTMLElement;
            if (pointerNone) {
                const element = pointerNone.querySelector('.fields-ele-container, .tag-container, .droplist-menu');
                if (element) {
                    this.renderer.removeClass(element, 'pointer-none');
                }
            }
            if (droplistPointerNone) {
                const element = droplistPointerNone.querySelector('.droplist-menu');
                if (element) {
                    this.renderer.removeClass(element, 'pointer-none');
                }
            }
            if (field.type == 'datepicker') {
                let datepickerField = document.querySelector('[uuid="' + field.uuid + '"] .datepicker-field');
                if (!datepickerField) {
                    datepickerField = document.querySelector('[uuid="' + field.uuid + '"] input');
                }
                this.globalService.initializeFlatpicker(datepickerField);
                this.domHelperService.initializeEventListener(document.querySelectorAll('.drag-fields[uuid="' + field.uuid + '"]'), 'mousedown', 'openDatepicker');
            }
            if (assignee) {
                this.initTheAssigneeEventListner(assignee, "0", roleDetail, isEform);
            }
            if (pointerNone) {
                const inputs = pointerNone.querySelectorAll('input, textarea');
                inputs.forEach((input: HTMLElement) => {
                    if(input.classList.contains('text-field-textarea')){
                        this.globalService.autoHeightForTextarea(input as HTMLTextAreaElement);  
                    }
                    this.renderer.removeAttribute(input, 'tabindex');
                });
            }
            if (field.tag_view == "1") {
                this.updateStylePropertyOfTag(false, field.uuid, roleDetail.role_color);
            }
            if (pointerNone) {
                this.renderer.removeClass(pointerNone, 'pointer-none');
            }
            this.setFieldEditing(true, senderInput, senderTextarea, pointerNone, field);
        } else {
            const dragField = document.querySelector('.drag-fields[uuid="' + field.uuid + '"]') as HTMLElement;
            const senderInput = document.querySelector('.drag-fields[uuid="' + field.uuid + '"] input') as HTMLElement;
            const senderTextarea = document.querySelector('.drag-fields[uuid="' + field.uuid + '"] textarea') as HTMLElement;
            this.setFieldEditing(false, senderInput, senderTextarea, dragField, field);
            if (senderInput) {
                this.renderer.setAttribute(senderInput, 'tabindex', '-1');
            }
            if (senderTextarea) {
                this.renderer.setAttribute(senderTextarea, 'tabindex', '-1');
                this.globalService.autoHeightForTextarea(senderTextarea as HTMLTextAreaElement);
            }
            if (dragField) {
                this.renderer.addClass(dragField, 'pointer-none');
            }
            if (field.tag_view == "1") {
                this.updateStylePropertyOfTag(true, field.uuid);
            }
        }
    }

    updateStylePropertyOfTag(removeStyle: boolean, uuid, color: string = '') {
        const fieldElement = document.querySelector('.drag-fields[uuid="' + uuid + '"]');
        const tagElement = fieldElement?.querySelector('.tag-container');
        if (tagElement) {
            const textTag = tagElement?.querySelector('.selected-label') as HTMLElement;
            if (textTag) {
                if (removeStyle) {
                    this.renderer.removeStyle(textTag, 'color');
                } else {
                    this.renderer.setStyle(textTag, 'color', color);
                }
            }
        }
        //this is for the eform last step
        const templateMessagePage = document.querySelector('.template-message-page .drag-fields[uuid="' + uuid + '"]');
        if(templateMessagePage){
        const tagElement = templateMessagePage?.querySelector('.tag-container');
            if(tagElement){
                const textTag = tagElement?.querySelector('.selected-label') as HTMLElement;
                if(textTag){
                    this.renderer.removeStyle(textTag, 'color');
                }
                this.domHelperService.initializeEventListener(document.querySelectorAll('.open-tag-popover[uuid="' + uuid + '"]'), 'click', 'emptyEvent');
            }
        }
    }

    /**
     * event listening for the each block
     * @param uuid 
     * @param fields_data 
     * @param roleDetail 
     */
    blockAssigner(uuid: string, fields_data: object, roleDetail: RoleDetail, isEform:boolean) {
        const block: Block = fields_data['blocks'][uuid];
        if (block.type == "attachment") {
            if ((Number(block.request_from) == roleDetail.id || block.request_from == -1) && ([this.signingStatusEnum.SENT, this.signingStatusEnum.DELIVERED, this.signingStatusEnum.VIEWED].includes(roleDetail.recipient_role_detail?.status) || isEform)) {
                const assignee = document.querySelector('.attachment-block-upload[uuid="' + block.uuid + '"]') as HTMLElement;
                if (assignee) {
                    this.initTheAssigneeEventListner(assignee, "0", roleDetail, isEform);
                }
            } else {
                const assignee = document.querySelector('.attachment-block-upload[uuid="' + block.uuid + '"]') as HTMLElement;
                if (assignee) {
                    assignee.querySelectorAll('.attachmentBox').forEach((ele) => {
                        this.renderer.addClass(ele, 'disable-hover');
                    });
                    const attachmentBlock = assignee.closest('.attachment-block');
                    if(attachmentBlock){
                        this.renderer.addClass(attachmentBlock, 'disable-hover');
                    }
                }
            }
            this.domHelperService.initializeEventListener('.attachment-block-upload a', 'click', 'viewAttachment', { role_id: roleDetail?.id, roleDetail: roleDetail });
        } else if (block.type == "upload-pdf") {
            if ((Number(block.request_from) == roleDetail.id || block.request_from == -1) && ([this.signingStatusEnum.SENT, this.signingStatusEnum.DELIVERED, this.signingStatusEnum.VIEWED].includes(roleDetail.recipient_role_detail?.status) || isEform)) {
                const assignee = document.querySelector('.pdf-block-upload[uuid="' + block.uuid + '"]') as HTMLElement;
                if(assignee){
                    this.initTheAssigneeEventListner(assignee, block.uuid, roleDetail, isEform);
                }
            }
        } else if (block.type == "product-table") {
            if ((Number(block.request_from) == roleDetail.id || block.request_from == -1) && ([this.signingStatusEnum.SENT, this.signingStatusEnum.DELIVERED, this.signingStatusEnum.VIEWED].includes(roleDetail.recipient_role_detail?.status) || isEform)) {
                this.productTable.initializeOnSigningArea(block.uuid, roleDetail, isEform);
            }
        }
    }

    /**
   * init the event listerns only for the assignee
   * @param assignee 
   */
    initTheAssigneeEventListner(assignee: HTMLElement, uuid: string = "0", roleDetail: RoleDetail, isEform:boolean) {
        const role_id = roleDetail.id;
        if (assignee?.querySelectorAll('.multiChoice-box').length) {
            this.domHelperService.initializeEventListener(assignee?.querySelectorAll('.multiChoice-box'), 'click', 'multiChoiceAction', { role_id: role_id });
        }

        if (assignee?.querySelectorAll('.text-tag-editor,.text-field-input,.text-field-textarea').length) {
            this.domHelperService.initializeEventListener(assignee?.querySelectorAll('.text-tag-editor,.text-field-input,.text-field-textarea'), 'keyup', 'updateFieldOnKeyUp', { role_id: role_id });
            this.domHelperService.initializeEventListener(assignee?.querySelectorAll('.text-tag-editor,.text-field-input,.text-field-textarea'), 'blur', 'updateFieldOnBlur', { role_id: role_id });
            this.domHelperService.initializeEventListener(assignee?.querySelectorAll('.text-field-input'), 'focus', 'onTextFieldFocus', { role_id: role_id, area: AreaType.Signing });
            this.domHelperService.initializeEventListener(assignee?.querySelectorAll('.text-field-input'), 'click', 'onTextFieldFocus', { role_id: role_id, area: AreaType.Signing });
        }

        if (assignee?.querySelectorAll('.tag-container').length) {
            const getUuid = assignee?.querySelector('.tag-container').closest('.open-tag-popover').getAttribute('uuid');
            this.domHelperService.initializeEventListener(document.querySelectorAll('.open-tag-popover[uuid="' + getUuid + '"]'), 'click', 'openTagPopover', { role_id: role_id, hide_settings: true });
        }

        if (assignee?.querySelectorAll('.search-drop-value').length) {
            this.domHelperService.initializeEventListener(assignee?.querySelectorAll('.search-drop-value'), 'keyup', 'searchDropDownLabelOnKeyUp', { role_id: role_id });
        }

        if (assignee?.querySelectorAll('.droplist-menu').length) {
            this.domHelperService.initializeEventListener(assignee?.querySelectorAll('.droplist-menu'), 'click', 'openDropListMenu', { role_id: role_id });
        }

        if (assignee?.querySelectorAll('.checkbox-field-box').length) {
            this.domHelperService.initializeEventListener(assignee?.querySelectorAll('.checkbox-field-box'), 'click', 'toggleCheckBox', { role_id: role_id });
        }

        if (assignee?.querySelectorAll('.signature-field-inner-container').length) {
            this.domHelperService.initializeEventListener(assignee?.querySelectorAll('.signature-field-inner-container'), 'click', 'addSignature', { role_id: role_id, roleDetail: roleDetail, isEform });
        }

        if (assignee?.getAttribute('type') == "attachment") {
            this.domHelperService.initializeEventListener('.attachment-block-upload', 'click', 'uploadAttachment', { role_id: role_id, roleDetail: roleDetail, isEform });
            this.domHelperService.initializeEventListener('input.attachment-uploader', 'change', 'attachmentUploader', { role_id: role_id, roleDetail: roleDetail, isEform });
            this.domHelperService.initializeEventListener('.delete-attachment-file', 'click', 'deleteAttachment', { role_id: role_id, roleDetail: roleDetail, isEform });
        }

        if (assignee?.getAttribute('type') == "Upload pdf") {
            this.domHelperService.initializeEventListener('.pdf-block-upload[uuid="' + uuid + '"]', 'click', 'uploadUploadPdf', { role_id: role_id, roleDetail: roleDetail, isEform });
            this.domHelperService.initializeEventListener('input.pdf-block-uploader', 'change', 'pdfUploader', { role_id: role_id, roleDetail: roleDetail, isEform });
        }

    }

    private setFieldEditing( isEditable: boolean, senderInput: HTMLElement | null, senderTextarea: HTMLElement | null, fieldElement: HTMLElement | null, field: Field): void {
        if (senderInput) {
            if (isEditable) {
            this.renderer.removeAttribute(senderInput, 'readonly');
            } else {
            this.renderer.setAttribute(senderInput, 'readonly', 'true');
            }
        }

        if (senderTextarea) {
            if (isEditable) {
            this.renderer.removeAttribute(senderTextarea, 'readonly');
            } else {
            this.renderer.setAttribute(senderTextarea, 'readonly', 'true');
            }
        }

        if (fieldElement) {
            const requiredValue = isEditable ? (field?.field_required ?? '0') : '0';
            this.renderer.setAttribute(fieldElement, 'field_required', requiredValue);
        }
    }
}